import Api from "../../Api";

export const createSailingPageData = async (data) => {
  try {
    let res = await Api.post("/sailing-page", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getSailingPageData = async (query) => {
  try {
    let res = await Api.get("/sailing-page", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const exportSailingPageData = async (query) => {
  try {
    let res = await Api.get("/sailing-page/export", {
      responseType: "arraybuffer",
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteSailingPageData = async (vesselId, id) => {
  try {
    let res = await Api.delete(`/sailing-page/${vesselId}/${id}`);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateSailingPageData = async (id, data) => {
  try {
    let res = await Api.patch("/sailing-page/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const getCurrentActiveSailing = async (vesselId) => {
  try {
    let res = await Api.get("/sailing-page/active-sailing/" + vesselId);

    return res?.data || {};
  } catch (e) {
    return { error: "Failed to fetch active sailing" };
  }
};

export const updateCurrentActiveSailing = async (id, data) => {
  try {
    let res = await Api.put("/sailing-page/active-sailing/" + id, data);

    return res?.data || {};
  } catch (e) {
    return { error: "Failed to Update active sailing" };
  }
};
